/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface TeamMemberAvailabilityPeriod {
  id: string;
  startDate: string;
  endDate?: string | null;
  title?: TeamMemberAvailabilityPeriodTitleEnum;
  description?: string | null;
  employmentPercentage?: number;
  isManuallyEdited?: boolean;
  canManuallyEdit?: boolean;
}
export enum TeamMemberAvailabilityPeriodTitleEnum {
  Terminated = 'Terminated',
  Dormant = 'Dormant',
  Active = 'Active',
  Other = 'Other'
}
